import React from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';

import { GLOBAL_VENDOR_THIRD_PARTY_OPTIONS } from 'lib/networking/endpoints';
import useGet from 'lib/hooks/useGet';

function ThirdPartyDropdown({
  value,
  onChange,
  placeholder = 'Select Third Party',
  isClearable = true,
  isDisabled = false,
  skip = false,
}) {
  const { data: thirdPartyData, loading } = useGet(GLOBAL_VENDOR_THIRD_PARTY_OPTIONS, {}, skip);

  const options =
    thirdPartyData?.data?.map(item => ({
      label: item,
      value: item,
    })) || [];

  return (
    <Select
      value={value}
      options={options}
      onChange={onChange}
      isSearchable
      isClearable={isClearable}
      isLoading={loading}
      isDisabled={isDisabled}
      placeholder={placeholder}
    />
  );
}

ThirdPartyDropdown.propTypes = {
  value: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  isClearable: PropTypes.bool,
  isDisabled: PropTypes.bool,
  skip: PropTypes.bool,
};

export default ThirdPartyDropdown;
